import React, { useRef, useImperativeHandle, forwardRef } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";

// Mk Player
import "@mediakind/mkplayer/mkplayer-ui.css";
import * as MKPlayerSDK from "@mediakind/mkplayer";

// Material
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    position: "relative",
    width: "70vw",
    height: "39.375vw",
    maxHeight: "90vh",
    objectFit: "cover",
    borderRadius: "4px",
    display: "flex",
    overflow: "hidden",
    backgroundColor: "#000",
    [theme.breakpoints.down("xs")]: {
      width: "100vw",
      height: "56.25vw",
      borderRadius: 0
    }
  },
  video: {
    height: "100%",
    objectFit: "cover",
    margin: "0 auto",
    "& video": {
      height: "100%",
      width: "100%",
      objectFit: "cover"
    }
  }
}));
const HLSVideoPlayer = forwardRef(({ className }, ref) => {
  const classes = useStyles();
  const vContainerRef = useRef(null);
  const playerRef = useRef(null);

  useImperativeHandle(ref, () => ({
    async playWithData(data) {
      const playerConfig = {
        key: process.env.REACT_APP_MKPLAYER_KEY,
        ui: true,
        playback: {
          muted: false,
          autoplay: false
        }
      };

      const sourceConfig = {
        hls: data.hls,
        dash: data.dash
      };

      const MAX_RETRIES = 3;
      const RETRY_DELAY_MS = 500;

      const attemptPlay = async (attempt = 1) => {
        try {
          if (playerRef.current) {
            await playerRef.current.unload();
            playerRef.current.destroy();
            playerRef.current = null;
          }

          playerRef.current = new MKPlayerSDK.MKPlayer(
            vContainerRef.current,
            playerConfig
          );

          await playerRef.current.load(sourceConfig);
          await playerRef.current.play();
        } catch (error) {
          if (attempt < MAX_RETRIES) {
            setTimeout(
              () => attemptPlay(attempt + 1),
              RETRY_DELAY_MS * attempt
            );
          }
        }
      };
      await attemptPlay();
    }
  }));
  return (
    <div className={classes.root}>
      <div
        ref={vContainerRef}
        className={clsx(className, classes.video)}
        id="video-container"
      />
    </div>
  );
});

HLSVideoPlayer.propTypes = {
  className: PropTypes.string
};

HLSVideoPlayer.defaultProps = {
  className: ""
};

export default HLSVideoPlayer;
